<template>
    <div class="sort-byfield">
      SORT BY FIELD

    </div>
</template>

<script>

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType'],
  data() {
    return {
      input_mask: '##/##/####',
    };
  },
};
</script>

<style scoped>



// WEBPACK FOOTER //
// src/components/interactive/widgets/SortByfield.vue?427f8030